// extracted by mini-css-extract-plugin
export default {"form":"DevicePreviewModal-module__form--SS+d9","footer":"DevicePreviewModal-module__footer--H3sp2"};